// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("bs-platform/lib/js/js_dict.js");
var Js_json = require("bs-platform/lib/js/js_json.js");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");

function connection_type_encode(ct) {
  switch (ct) {
    case /* Git */0 :
        return "git";
    case /* Pagure */1 :
        return "pagure";
    case /* Gerrit */2 :
        return "gerrit";
    case /* Gitlab */3 :
        return "gitlab";
    case /* Github */4 :
        return "github";
    
  }
}

function connection_type_decode(json) {
  var match = Js_json.decodeString(json);
  if (match === undefined) {
    return Decco.error(undefined, "unknown connection type", json);
  }
  switch (match) {
    case "gerrit" :
        return {
                TAG: /* Ok */0,
                _0: /* Gerrit */2
              };
    case "git" :
        return {
                TAG: /* Ok */0,
                _0: /* Git */0
              };
    case "github" :
        return {
                TAG: /* Ok */0,
                _0: /* Github */4
              };
    case "gitlab" :
        return {
                TAG: /* Ok */0,
                _0: /* Gitlab */3
              };
    case "pagure" :
        return {
                TAG: /* Ok */0,
                _0: /* Pagure */1
              };
    default:
      return Decco.error(undefined, "unknown connection type", json);
  }
}

function t_encode(v) {
  return Js_dict.fromArray([
              [
                "name",
                Decco.stringToJson(v.name)
              ],
              [
                "base-url",
                Decco.optionToJson(Decco.stringToJson, v.base_url)
              ],
              [
                "type",
                connection_type_encode(v.connection_type)
              ]
            ]);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var base_url = Decco.optionFromJson(Decco.stringFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "base-url"), null));
    if (base_url.TAG === /* Ok */0) {
      var connection_type = connection_type_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "type"), null));
      if (connection_type.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  name: name._0,
                  base_url: base_url._0,
                  connection_type: connection_type._0
                }
              };
      }
      var e = connection_type._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".type" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = base_url._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".base-url" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

var decode = t_decode;

var encode = t_encode;

exports.connection_type_encode = connection_type_encode;
exports.connection_type_decode = connection_type_decode;
exports.t_encode = t_encode;
exports.t_decode = t_decode;
exports.decode = decode;
exports.encode = encode;
/* No side effect */
